import React from "react";
import { Alert, Box } from "@mui/material";
import "./styles/ImportUsersFromCSV.scss";

import FormDialog from "../../../../../components/Dialog/FormDialog";
import MuiTable from "../../../../admin/board/components/BoardTable/MuiTable";

function getPreviewColumns() {
  return [
    {
      field: "first_name",
      headerName: "First Name",
      renderCell: (params) => {
        const error = params.row?.errors?.first_name;
        const displayValue = params.value || "Required";

        return (
          <div
            className={
              error ? "invalid-cell user-preview-cell" : "user-preview-cell"
            }
          >
            {displayValue}
          </div>
        );
      },
      flex: 1.8,
      sortable: false,
      minWidth: 190,
    },
    {
      field: "last_name",
      headerName: "Last Name",
      renderCell: (params) => {
        const error = params.row?.errors?.last_name;
        const displayValue = params.value || "Required";

        return (
          <div
            className={
              error ? "invalid-cell user-preview-cell" : "user-preview-cell"
            }
          >
            {displayValue}
          </div>
        );
      },
      flex: 1.8,
      sortable: false,
      minWidth: 190,
    },
    {
      field: "email",
      headerName: "Email",
      renderCell: (params) => {
        const error = params.row?.errors?.email;
        const displayValue = params.value || "Required";

        return (
          <div
            className={
              error
                ? "invalid-cell user-preview-cell user-email-cell"
                : "user-preview-cell user-email-cell"
            }
          >
            {displayValue}
          </div>
        );
      },
      flex: 2.4,
      sortable: false,
      minWidth: 280,
    },
  ];
}

export default function ImportUsersFromCSV({
  errorMessage,
  hasInvalidRows,
  isSubmitting,
  onClose,
  open,
  previewRows,
  onSubmit,
}) {
  const columns = getPreviewColumns();

  return (
    <FormDialog
      open={open}
      handleClose={onClose}
      handleSubmit={onSubmit}
      title={"Import Users"}
      buttonTxt={"Submit"}
      disabled={!previewRows.length || hasInvalidRows || isSubmitting}
      fullWidth={true}
      width={749}
    >
      <div className="upload-user-csv preview-dialog">
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}

        <div className="preview-section">
          {hasInvalidRows && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              Fix the invalid rows before submitting invitations.
            </Alert>
          )}

          <Box sx={{ width: "100%" }}>
            <MuiTable
              initialRows={previewRows}
              columns={columns}
              pageSize={5}
              rowsPerPageOptions={[5]}
              defaultSort={"first_name"}
              headerBgColor={"#F2F4F6"}
              subHeight={330}
              minRowHeight={80}
              getRowHeight={() => "auto"}
              scrollHeight={"330px"}
            />
          </Box>
        </div>
      </div>
    </FormDialog>
  );
}
